import { useState, useEffect } from 'react';

const DEFAULT_IMAGE_URLS = [
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-1.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-2.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-3.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-4.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-5.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-6.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-7.png'
];

const sampleRandomImage = () => DEFAULT_IMAGE_URLS[Math.floor(Math.random() * DEFAULT_IMAGE_URLS.length)];

const useImage = (img = null, getFallback = sampleRandomImage) => {
  const [imageUrl, updateImageUrl] = useState(img || getFallback());

  useEffect(() => {
    if (!imageUrl) {
      updateImageUrl(getFallback());
    }
  }, [imageUrl]);

  return [imageUrl, updateImageUrl];
};

export default useImage;
